'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

let data = new Map();
const memoryStorage = {
  setItem(key, value) {
    data.set(key, value);
  },
  getItem(key) {
    return data.get(key);
  },
  removeItem(key) {
    return data.delete(key);
  },
  clear() {
    data = new Map();
  }
};
let internalStorage;
if (typeof window !== "undefined" && window.localStorage) {
  try {
    localStorage.setItem("test", "test");
    localStorage.removeItem("test");
    internalStorage = localStorage;
  } catch (e) {
    internalStorage = memoryStorage;
  }
} else {
  internalStorage = memoryStorage;
}
const storage = internalStorage;

exports.storage = storage;
